import { Component, OnInit } from '@angular/core';
import { OidcSecurityService, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-portal',
    templateUrl: './portal.component.html',
    styleUrls: ['./portal.component.sass'],
    standalone: false
})
export class PortalComponent implements OnInit {

  configuration$: Observable<OpenIdConfiguration | null> | undefined;
  givenName: string = '';

  constructor(
    private oidcSecurityService: OidcSecurityService){}

  ngOnInit(): void {
    this.configuration$ = this.oidcSecurityService.getConfiguration();
    this.oidcSecurityService.getUserData().subscribe(user => {
      this.givenName = user["given_name"];
    });
  }
}
